import styled from 'styled-components';
import { primaryColorLight } from '../../config/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilterContainer = styled.div`
  padding: 1rem 40px;
  border-bottom: 1px solid #f1f1f1;
  min-height: 150px;
`;

export const ResultContainer = styled.div``;

export const FilterHeader = styled.h4`
  margin: 0px;
  padding: 0px;
  padding-bottom: 1.2rem;
  font-size: 1.5rem;
  font-weight: 500;
`;

export const ControlWrapper = styled.div`
  padding: 10px 0px;
`;

export const LabelActionButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-top: 4px;
`;

export const LabelActionButton = styled.label`
  color: ${({ color }) => color || primaryColorLight};
  border-radius: 4px;
  border: 1px solid transparent;
  display: inline-block;
  height: 32px;
  width: 140px;
  font-size: 0.85rem;
  font-weight: 600;
  transition: opacity 0.2s ease-out, border-color 0.2s ease-out;
  cursor: pointer;
  line-height: 32px;
  padding-left: 14px;
  user-select: none;

  & .counter {
    color: ${primaryColorLight};
  }

  &:hover {
    border-color: ${({ color }) => color || primaryColorLight};
    opacity: 0.9;
  }
`;
